'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _personalDetails = require('redux/modules/personalDetails');

var personalDetails = _interopRequireWildcard(_personalDetails);

var _infoBlock = require('redux/modules/infoBlock');

var infoBlock = _interopRequireWildcard(_infoBlock);

var _auth = require('redux/modules/auth');

var auth = _interopRequireWildcard(_auth);

var _components = require('components');

var _containers = require('containers');

var _saveUserData = require('redux/modules/saveUserData');

var _htmlToReact = require('html-to-react');

var _reactContentLoader = require('react-content-loader');

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _semanticUiReact = require('semantic-ui-react');

require('./VEditor.css');

var _commonFunctions = require('../../utils/commonFunctions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactDOMServer = require('react-dom/server');
var reactStringReplace = require('react-string-replace');
// import Joyride from 'react-joyride';
// import './react-joyride-compiled.css';
// import 'react-joyride/lib/react-joyride-compiled.css';

var styles = require('./VEditor.scss');

// ========== HTML TO react-router
var customElements = {
  "singleline": _components.SingleLine
  //"multiline": MultiLine,
  //"databox": DataBox,
};

var MyLoader = function MyLoader() {
  return _react2.default.createElement(
    _reactContentLoader2.default,
    { height: 70, speed: 2 },
    _react2.default.createElement(_reactContentLoader.Rect, { x: 50, y: 20, height: 10, radius: 5, width: 300 }),
    _react2.default.createElement(_reactContentLoader.Rect, { x: 0, y: 40, height: 10, radius: 5, width: 400 }),
    _react2.default.createElement(_reactContentLoader.Rect, { x: 75, y: 60, height: 10, radius: 5, width: 250 })
  );
};

// Boilerplate stuff
var htmlParser = new _htmlToReact.Parser(_react2.default);
var processNodeDefinitions = new _htmlToReact.ProcessNodeDefinitions(_react2.default);
function isValidNode() {
  return true;
}

var VEditor = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    design_template_id: state.templateData.design_template_id,
    design_template_data: state.templateData.design_template_data,
    design_template_name: state.templateData.design_template_name,
    resume_name: state.templateData.resume_name,
    content_template_id: state.templateData.content_template_id,
    content_template_data: state.templateData.content_template_data,
    content_template_name: state.templateData.content_template_name,
    loading_design: state.templateData.loading_design,
    loaded_design: state.templateData.loaded_design,
    loading_content: state.templateData.loading_content,
    loaded_content: state.templateData.loaded_content,
    personal_loaded: state.personalDetails,
    personal_info: state.templateData.personal_info,
    info_loaded: state.templateData.info_block,
    saving_data: state.saveUserData.loading,
    saved_data: state.saveUserData.loaded,
    design_order: state.templateData.design_order,
    printing: state.templateData.printing,
    printing_success: state.templateData.printing_success,
    print_url: state.templateData.print_url,
    subscribed: state.auth.subscribed,
    design_template_free: state.templateData.design_template_free,
    content_template_free: state.templateData.content_template_free,
    inter_section_margin: state.templateData.inter_section_margin,
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    header_font: state.templateData.header_font,
    body_font: state.templateData.body_font,
    resume_review_id: state.templateData.resume_review_id,
    ReactGA: state.company.ReactGA,
    company: state.company.name,
    base_url: state.company.base_url,
    show_resume_review_on_download: state.company.show_resume_review_on_download,
    user_data_id: state.templateData.user_data_id,
    basic_builder: state.company.basic_builder,
    basic_builder_print_design: state.templateData.basic_builder_print_design,
    show_section_editor: state.templateData.show_section_editor,
    show_social_editor: state.templateData.show_social_editor,
    all_templates_free: state.company.all_templates_free,
    type_of_document: state.company.type_of_document,
    analysis_mode_on: state.templateData.analysis_mode_on,
    show_save_button: state.company.show_save_button
  };
}, {
  pushState: _reactRouterRedux.push,
  updatePersonalDetails: personalDetails.updateBlock,
  addInfo: infoBlock.addBlock,
  cleanTemplateData: templateActions.clean,
  cleanInfo: infoBlock.clean,
  printPDF: templateActions.printPDF,
  updateInterSectionMargin: templateActions.updateInterSectionMargin,
  updatePrimaryColor: templateActions.updatePrimaryColor,
  updateSecondaryColor: templateActions.updateSecondaryColor,
  updateHeaderFont: templateActions.updateHeaderFont,
  updateBodyFont: templateActions.updateBodyFont,
  saveUserData: _saveUserData.save,
  createCookie: auth.createCookie,
  eraseCookie: auth.eraseCookie,
  readCookie: auth.readCookie,
  loadDesignTemplateData: templateActions.loadDesignTemplateData,
  loadContentTemplateData: templateActions.loadContentTemplateData,
  loadSavedUserData: templateActions.loadSavedUserData,
  chooseTemplate: templateActions.chooseTemplate
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VEditor, _Component);

  function VEditor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VEditor.__proto__ || (0, _getPrototypeOf2.default)(VEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      side_nav_visible: true,
      primary_color: false,
      secondary_color: false,
      modalOpen: false,
      activeItem: 'home',
      saving_data: _this.props.saving_data,
      loading: true,
      printing: false,
      printing_success: false,
      upgrade: false,
      generated_JSX_databox: false,
      shadow_generated_JSX_databox: false,
      shadowElementVisible: false,
      section_margin: _this.props.inter_section_margin,
      resume_analysis_visible: false,
      saved_once: false,
      //joyride code
      joyrideOverlay: true,
      joyrideType: 'continuous',
      isReady: true,
      isRunning: false,
      stepIndex: 0,
      autoStart: true,
      scrollOffset: 200,
      disableOverlay: true,
      steps: [{
        title: 'Let us start making your résumé!',
        text: '- You can directly edit all the sections in the résumé itself.',
        selector: '.SUM',
        position: 'top',
        allowClicksThruHole: false,
        style: {
          beacon: {
            inner: '#27e200',
            offsetX: 20,
            offsetY: 20,
            outer: '#27e200'
          },
          hole: {
            // marginTop: '15px'
          }
        }
      }, {
        title: 'Move, Add & Delete sections',
        text: '- Use the 3 buttons on the top left of each section.',
        selector: '.PR',
        position: 'left',
        allowClicksThruHole: true,
        type: 'hover',
        style: {
          beacon: {
            inner: '#27e200',
            offsetX: -200,
            offsetY: 20,
            outer: '#27e200'
          }
        }
      }, {
        title: 'Auto-Saved Résumés',
        text: '- Each unique design - profile combination is auto saved. <br>- All the saved résumés are available in your dashboard.',
        selector: '.dashboard-label',
        position: 'bottom',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          beacon: {
            inner: '#27e200',
            offsetX: 20,
            outer: '#27e200'
          },
          arrow: {
            display: 'none'
          }
        }
      }, {
        title: 'Change Résumé Design',
        text: '- Want to select a new design? Click here. <br>- All of your info will be copied to the new design.',
        selector: '.item-2',
        position: 'top',
        isFixed: true,
        style: {
          beacon: '#000'
        }
      }, {
        title: 'You\'re all set to go!',
        text: '- Just ping us for any issues or feedback.',
        selector: '.segment',
        position: 'bottom',
        isFixed: true,
        style: {
          arrow: {
            display: 'none'
          }
        }
      }],
      selector: ''
    }, _this.addCompleteStyling = function (data) {
      _this.addColorStyling('primary', _this.props.primary_color);
      _this.addColorStyling('secondary', _this.props.secondary_color);
      _this.addFontStyling('header', _this.props.header_font);
      _this.addFontStyling('body', _this.props.body_font);
      _this.addSectionSpacing(_this.props.inter_section_margin);
      _this.addGradient(_this.props.primary_color, _this.props.secondary_color);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VEditor, [{
    key: 'callback',


    //Joyride Code Starts ......................................................


    // addSteps(steps) {
    //     let newSteps = steps;
    //
    //     if (!Array.isArray(newSteps)) {
    //       newSteps = [newSteps];
    //     }
    //
    //     if (!newSteps.length) {
    //       return;
    //     }
    //
    //     // Force setState to be synchronous to keep step order.
    //     this.setState(currentState => {
    //       currentState.steps = currentState.steps.concat(newSteps);
    //       return currentState;
    //     });
    //   }

    // addTooltip(data) {
    //   this.joyride.addTooltip(data);
    // }
    //
    // next() {
    //   this.joyride.next();
    // }

    value: function callback(data) {
      // console.log('%ccallback', 'color: #47AAAC; font-weight: bold; font-size: 13px;'); //eslint-disable-line no-console
      this.setState({
        selector: data.type === 'tooltip:before' ? data.step.selector : ''
      });
      if (data.type === 'finished') {
        //this code is fired when the tour ends.
        (0, _auth.createCookie)('joyride', true, 999);
        this.props.ReactGA.event({
          category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
          action: 'Joyride - End',
          label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
        });
      }
      if (data.type === 'error:target_not_found') {
        this.setState({
          isRunning: false,
          isReady: false
        });
        this.joyride.next();
      }
      if (data.action == 'next' || data.action == 'back' || data.action == 'skip' || data.action == 'close') {
        if (data.type == 'step:after') {
          this.props.ReactGA.event({
            category: 'Resume - Create Resume ' + this.props.design_template_name + ' - ' + this.props.content_template_name,
            action: 'Joyride - ' + data.action,
            label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
          });
        }
      }
    }

    // onClickSwitch(e) {
    //   e.preventDefault();
    //   const el = e.currentTarget;
    //   const state = {};
    //
    //   if (el.dataset.key === 'joyrideType') {
    //     this.joyride.reset();
    //
    //     setTimeout(() => {
    //       this.setState({
    //         isRunning: true,
    //       });
    //     }, 300);
    //
    //     state.joyrideType = e.currentTarget.dataset.type;
    //   }
    //
    //   if (el.dataset.key === 'joyrideOverlay') {
    //     state.joyrideOverlay = el.dataset.type === 'active';
    //   }
    //
    //   this.setState(state);
    // }


    //Joyride Code Ends .............................................


  }, {
    key: 'addHeadScript',
    value: function addHeadScript(src) {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      head.appendChild(script);
    }
  }, {
    key: 'addColorStyling',
    value: function addColorStyling(styleClass, colorHex) {

      var elements = document.getElementsByClassName(styleClass + '-color');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.color = colorHex;
      }

      var elements = document.getElementsByClassName(styleClass + '-background');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundColor = colorHex;
      }

      var elements = document.getElementsByClassName(styleClass + '-border');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.borderColor = colorHex;
      }
    }
  }, {
    key: 'addFontStyling',
    value: function addFontStyling(styleClass, fontName) {

      var elements = document.getElementsByClassName(styleClass + '-font');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.fontFamily = fontName;
      }
      // special case for draft component
      if (styleClass === 'body') {
        var elements = document.getElementsByClassName('editor-root');
        for (var i = 0; i < elements.length; i++) {
          elements[i].style.fontFamily = fontName;
        }
      }
    }
  }, {
    key: 'addSectionSpacing',
    value: function addSectionSpacing(lineSpacing) {
      var lineSpacingString = lineSpacing + 'px';
      var elements = document.getElementsByClassName('section-padding-top');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.paddingTop = lineSpacingString;
      }
      var elements = document.getElementsByClassName('section-padding-bottom');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.paddingBottom = lineSpacingString;
      }
      var elements = document.getElementsByClassName('section-margin-top');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.marginTop = lineSpacingString;
      }
      var elements = document.getElementsByClassName('section-margin-bottom');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.marginBottom = lineSpacingString;
      }
    }
  }, {
    key: 'addGradient',
    value: function addGradient(primaryColor, secondaryColor) {
      var elements = document.getElementsByClassName('gradient-top-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundImage = '-webkit-linear-gradient(top, ' + primaryColor + ' 0%, ' + secondaryColor + ' 100%)';
      }

      var elements = document.getElementsByClassName('gradient-left-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundImage = '-webkit-linear-gradient(left, ' + primaryColor + ' 0%, ' + secondaryColor + ' 100%)';
      }

      var elements = document.getElementsByClassName('gradient-right-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundImage = '-webkit-linear-gradient(right, ' + primaryColor + ' 0%, ' + secondaryColor + ' 100%)';
      }

      var elements = document.getElementsByClassName('gradient-bottom-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.backgroundImage = '-webkit-linear-gradient(bottom, ' + primaryColor + ' 0%, ' + secondaryColor + ' 100%)';
      }

      var elements = document.getElementsByClassName('gradient-border-left-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.webkitBorderImage = '-webkit-linear-gradient(left, ' + primaryColor + ' 0%,' + secondaryColor + ' 100%) 0 1 100%';
      }

      var elements = document.getElementsByClassName('gradient-border-right-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.webkitBorderImage = '-webkit-linear-gradient(right, ' + primaryColor + ' 0%,' + secondaryColor + ' 100%) 0 1 100%';
      }

      var elements = document.getElementsByClassName('gradient-border-top-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.webkitBorderImage = '-webkit-linear-gradient(top, ' + primaryColor + ' 0%,' + secondaryColor + ' 100%) 0 1 100%';
      }

      var elements = document.getElementsByClassName('gradient-border-bottom-true');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.webkitBorderImage = '-webkit-linear-gradient(bottom, ' + primaryColor + ' 0%,' + secondaryColor + ' 100%) 0 1 100%';
      }
    }
  }, {
    key: 'getLastEditTime',
    value: function getLastEditTime(date) {
      var d = new Date(date);
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      var day = days[d.getDay()];
      var hr = d.getHours();
      var min = d.getMinutes();
      if (min < 10) {
        min = '0' + min;
      }
      var ampm = hr < 12 ? ' am' : ' pm';
      var date = d.getDate();
      var month = months[d.getMonth()];
      var year = d.getFullYear();
      return 'Last Saved: ' + ' ' + hr + ':' + min + ampm + ' ' + date + ' ' + month + ' ' + year;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props != nextProps) {

        if (!this.state.saved_once && nextProps.saved_data) {
          this.setState({ saved_once: true });
        }

        if (nextProps.loaded_content && !nextProps.loading_content && nextProps.loaded_design && !nextProps.loading_design || this.state.shadowElementVisible) {

          // if (!this.state.generated_JSX_databox){
          var design_template_data;
          if (nextProps.content_template_free || this.props.subscribed || this.props.all_templates_free) {
            design_template_data = '<div>' + nextProps.design_template_data + '</div>';
          } else {
            document.addEventListener('contextmenu', function (event) {
              event.preventDefault();
            });
            design_template_data = '<div><p style="text-align:center; padding-top: 8px">You are viewing a Premium Content Template. To Download or Copy this content template, upgrade to Premium.</p>' + nextProps.design_template_data + '</div>';
          }
          var generated_JSX_databox_pre = htmlParser.parseWithInstructions(design_template_data, isValidNode, this.processingInstructionsPreDataBox(nextProps));

          // console.log(generated_JSX_databox_pre);
          var generated_JSX_databox = htmlParser.parseWithInstructions(ReactDOMServer.renderToStaticMarkup(generated_JSX_databox_pre).replace(/&quot;/g, "'"), isValidNode, this.processingInstructionsPostDataBox(nextProps));

          // this.state.generated_JSX_databox = generated_JSX_databox;

          // }

          //TODO: definete optimization pending here. avoid rendering when only printing done
          // Check placed for basic_builder printing, this will be unset in the prinnode function
          if (!this.props.printing_success && !nextProps.printing_success && !nextProps.printing || this.props.printing_success && nextProps.printing_success && !nextProps.printing) {
            if (this.state.shadowElementVisible) {
              // Printing only when databox is set in the shadownode.
              this.setState({ shadow_generated_JSX_databox: generated_JSX_databox }, function () {
                _this2.printNode(_this2.shadowElement);
              });
              // this.setState({generated_JSX_databox: generated_JSX_databox}, () => {this.printNode(this.element)});
              this.setState({ shadowElementVisible: false });
            } else {
              this.setState({ generated_JSX_databox: generated_JSX_databox });
            }
          }
          this.setState({ loading: !nextProps.loaded_content });

          this.setState({
            primary_color: nextProps.primary_color
          });

          // First step ends
          //commenting out the code below- removing joyride

          // const loggedIn = readCookie('joyride');
          // if(loggedIn != 'true'){
          //   //Joyride Initiated
          //     this.setState({
          //       isReady: true,
          //       isRunning: true,
          //     });
          //   //this.joyride.next();
          //   // First step ends
          // }
        }

        if (!this.props.printing_success && nextProps.printing_success && !nextProps.printing) {
          this.setState({ printing_success: true });
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      // Normal load design, always needed
      if (this.props.params.id && !this.props.resume_name) {
        this.props.loadSavedUserData(this.props.params.id, true);
      } else {
        this.props.loadDesignTemplateData(this.props.design_template_id);
        // If user_data_id is present load that or if already loaded skip loading
        if (!this.props.loaded_content) {
          if (this.props.user_data_id) {
            this.props.loadSavedUserData(this.props.user_data_id);
          } else {
            // Load content template if user_data_id is not loaded
            this.props.loadContentTemplateData(this.props.content_template_id);
          }
        }

        if (!((0, _keys2.default)(this.props.info_loaded).length === 0 && this.props.info_loaded.constructor === Object)) {
          console.log('No update needed');
        } else if (this.props.content_template_data) {
          this.props.updatePersonalDetails(this.props.content_template_data.personal_info);
          this.props.content_template_data.info_block.map(function (data, index) {
            return _this3.props.addInfo(data);
          });
        } else {
          this.props.pushState(this.props.base_url + '/dashboard');
        }
      }
      // this.props.content_template_data.professional_info
      // .map((data, index) =>
      //   this.props.addProfessionalDetails(data)
      // );
      // this.props.content_template_data.miscellaneous_info
      // .map((data, index) =>
      //   this.props.addMiscellaneousInfo(data)
      // );
    }
  }, {
    key: 'processingInstructionsPreDataBox',
    value: function processingInstructionsPreDataBox(data) {
      return [
      // Create instruction for custom elements
      // {
      //    // This is REQUIRED, it tells the parser
      //    // that we want to insert our React
      //    // component as a child
      //    replaceChildren: false,
      //    shouldProcessNode: function (node) {
      //         return node.attribs && node.attribs['class'] === 'cv';
      //     },
      //     processNode: function (node, children, index) {
      //
      //         if (node.attribs['data-margin']) {
      //           this.state.section_margin = node.attribs['data-margin'];
      //         }
      //
      //         return null;
      //     }
      // },
      {
        // This is REQUIRED, it tells the parser
        // that we want to insert our React
        // component as a child
        replaceChildren: false,
        shouldProcessNode: function shouldProcessNode(node) {
          return node.attribs && node.attribs['class'] === 'sorting-wrapper';
        },
        processNode: function processNode(node, children, index) {
          var heading;
          if (node.attribs['data-heading']) {
            heading = node.attribs['data-heading'];
          } else {
            heading = '';
          }
          var dataHeadingStyleClass;
          if (node.attribs['data-heading-style-class']) {
            dataHeadingStyleClass = node.attribs['data-heading-style-class'];
          } else {
            dataHeadingStyleClass = '';
          }
          var styling;
          if (node.attribs['data-style-class']) {
            styling = node.attribs['data-style-class'];
          } else {
            styling = '';
          }
          var dataAspectRatio;
          if (node.attribs['data-aspect-ratio']) {
            dataAspectRatio = node.attribs['data-aspect-ratio'];
          } else {
            dataAspectRatio = '';
          }
          var dataSectionStyleClass;
          if (node.attribs['data-section-style-class']) {
            dataSectionStyleClass = node.attribs['data-section-style-class'];
          } else {
            dataSectionStyleClass = '';
          }
          var dataBlockClass;
          if (node.attribs['data-block-class']) {
            dataBlockClass = node.attribs['data-block-class'];
          } else {
            dataBlockClass = '';
          }

          if (!data.info_loaded[node.attribs['data-type']]) {
            return null;
          } else {
            return _react2.default.createElement('div', { 'data-order': node.attribs['data-order'],
              'data-type': node.attribs['data-type'],
              'data-class': 'sorting-wrapper-inside',
              'data-style-class': styling,
              'data-heading': heading,
              'data-heading-style-class': dataHeadingStyleClass,
              'data-section-style-class': dataSectionStyleClass,
              'data-aspect-ratio': dataAspectRatio,
              'data-block-class': dataBlockClass
            });
          }
        }
      },
      // Default processing
      {
        shouldProcessNode: function shouldProcessNode() {
          return true;
        },
        processNode: processNodeDefinitions.processDefaultNode
      }];
    }
    // Custom instructions for processing nodes

  }, {
    key: 'processingInstructionsPostDataBox',
    value: function processingInstructionsPostDataBox(data) {
      return [
      // Create instruction for custom elements
      {
        // This is REQUIRED, it tells the parser
        // that we want to insert our React
        // component as a child
        replaceChildren: false,
        shouldProcessNode: function shouldProcessNode(node) {
          return node.attribs && node.attribs['data-class'] === 'sorting-wrapper-inside';
        },
        processNode: function processNode(node, children, index) {
          var heading;
          if (node.attribs['data-heading']) {
            heading = node.attribs['data-heading'];
          } else {
            heading = '';
          }
          var dataHeadingStyleClass;
          if (node.attribs['data-heading-style-class']) {
            dataHeadingStyleClass = node.attribs['data-heading-style-class'];
          } else {
            dataHeadingStyleClass = '';
          }
          var styling;
          if (node.attribs['data-style-class']) {
            styling = node.attribs['data-style-class'];
          } else {
            styling = '';
          }
          var dataSectionStyleClass;
          if (node.attribs['data-section-style-class']) {
            dataSectionStyleClass = node.attribs['data-section-style-class'];
          } else {
            dataSectionStyleClass = '';
          }
          var dataAspectRatio;
          if (node.attribs['data-aspect-ratio']) {
            dataAspectRatio = node.attribs['data-aspect-ratio'];
          } else {
            dataAspectRatio = '';
          }
          var dataBlockClass;
          if (node.attribs['data-block-class']) {
            dataBlockClass = node.attribs['data-block-class'];
          } else {
            dataBlockClass = '';
          }

          return _react2.default.createElement(_components.Sortable, { firstPass: false, heading: heading, dataBlockClass: dataBlockClass, dataAspectRatio: dataAspectRatio, dataSectionStyleClass: dataSectionStyleClass, dataHeadingStyleClass: dataHeadingStyleClass, dataStyleClass: styling, child: false, dataOrder: node.attribs['data-order'], dataParent: node.attribs['data-type'] });
        }
      }, {
        shouldProcessNode: function shouldProcessNode(node) {
          // Process the node if it matches a custom element.
          return node.name && customElements[node.name];
        },
        processNode: function processNode(node, children, index) {
          var CustomElement = customElements[node.name];
          var data_value;
          var value;
          var data_type = node.attribs['data-type'];
          // Test if data coming from content template or coming from saved data
          if (data.personal_loaded) {
            var info_dict = data.personal_loaded;
            data_value = info_dict[data_type];
          } else {
            var _info_dict = data.content_template_data.personal_info;
            data_value = _info_dict[data_type];
          }

          if (data_value) {
            value = data_value;
          } else {
            value = node.attribs['value'];
          }
          var textAreaColorClass;
          if (node.attribs['data-personal-class']) {
            textAreaColorClass = node.attribs['data-personal-class'];
          } else {
            textAreaColorClass = '';
          }
          return _react2.default.createElement(CustomElement, {
            placeholder: node.attribs['placeholder'],
            defaultValue: value,
            data_id: '1',
            data_parent: 'personal',
            data_type: data_type,
            style: node.attribs['data-style'],
            textAreaColorClass: textAreaColorClass
          });
        }
      }, {
        shouldProcessNode: function shouldProcessNode(node) {
          // Process the node if it matches a custom element.
          return node.name && node.name == 'socialcomponent';
        },
        processNode: function processNode(node, children, index) {

          var social_data;
          if (data.personal_info.social_data) {
            social_data = data.personal_info.social_data;
          } else {
            social_data = '';
          }

          var socialIconClass;
          if (node.attribs['data-social-icon-class']) {
            socialIconClass = node.attribs['data-social-icon-class'];
          } else {
            socialIconClass = '';
          }

          var socialTextClass;
          if (node.attribs['data-social-text-class']) {
            socialTextClass = node.attribs['data-social-text-class'];
          } else {
            socialTextClass = '';
          }

          var socialCombinedClass;
          if (node.attribs['data-social-combined-class']) {
            socialCombinedClass = node.attribs['data-social-combined-class'];
          } else {
            socialCombinedClass = '';
          }

          var socialWrapperClass;
          if (node.attribs['data-social-wrapper-class']) {
            socialWrapperClass = node.attribs['data-social-wrapper-class'];
          } else {
            socialWrapperClass = '';
          }

          return _react2.default.createElement(_components.SocialBox, {
            social_data: social_data,
            data_parent: 'social',
            socialWrapperClass: socialWrapperClass,
            socialCombinedClass: socialCombinedClass,
            socialTextClass: socialTextClass,
            socialIconClass: socialIconClass
          });
        }
      }, {
        // This is REQUIRED, it tells the parser
        // that we want to insert our React
        // component as a child
        replaceChildren: false,
        shouldProcessNode: function shouldProcessNode(node) {
          return node.attribs && node.attribs['class'] === 'wrap-it';
        },
        processNode: function processNode(node, children, index) {
          var styling;
          if (node.attribs['data-style-class']) {
            styling = node.attribs['data-style-class'];
          } else {
            styling = '';
          }
          var dataSectionStyleClass;
          if (node.attribs['data-section-style-class']) {
            dataSectionStyleClass = node.attribs['data-section-style-class'];
          } else {
            dataSectionStyleClass = '';
          }
          var dataBlockClass;
          if (node.attribs['data-block-class']) {
            dataBlockClass = node.attribs['data-block-class'];
          } else {
            dataBlockClass = '';
          }
          return _react2.default.createElement(_components.Sortable, { firstPass: false, dataBlockClass: dataBlockClass, dataSectionStyleClass: dataSectionStyleClass, dataStyleClass: styling, dataOrder: data.design_order, child: children });
        }
      },
      // Default processing
      {
        shouldProcessNode: function shouldProcessNode() {
          return true;
        },
        processNode: processNodeDefinitions.processDefaultNode
      }];
    }
  }, {
    key: 'download_resume',
    value: function download_resume(html) {
      if (this.props.basic_builder) {
        this.setState({ shadowElementVisible: true });
        this.props.loadDesignTemplateData(this.props.basic_builder_print_design);
      } else {
        this.printNode(html);
      }
    }
  }, {
    key: 'printNode',
    value: function printNode(html) {
      var object = {};
      object['personal'] = this.props.personal_info;
      object['info'] = this.props.info_loaded;
      object['design_template_id'] = this.props.design_template_id;
      object['content_template_id'] = this.props.content_template_id;
      object['design_order'] = this.props.design_order.toString();
      object['inter_section_margin'] = this.props.inter_section_margin;
      object['primary_color'] = this.props.primary_color;
      object['secondary_color'] = this.props.secondary_color;
      object['header_font'] = this.props.header_font;
      object['body_font'] = this.props.body_font;
      object['resume_name'] = this.props.resume_name;
      object['resume_review_id'] = this.props.resume_review_id;
      // Converting back to string so that consistency is maintained on data coming from server
      if (!this.props.basic_builder) this.props.saveUserData(object);
      // Check if user subscribed otherwise ask him to upgrade
      if (this.props.design_template_free || this.props.subscribed || this.props.all_templates_free || this.props.free_all || this.props.basic_builder) {
        var watermark = '';
        if (!this.props.subscribed) {
          watermark = '<footer style="text-align:center">Engineered by HIRATION | www.hiration.com</footer>';
        }
        var str = (0, _commonFunctions.createHTML)(html.innerHTML);
        // var replaced = ;
        // replaced = replaced.replace(/0 1 100% fill/g,"0 1 100%"); //have got to remove this before pushing the next features
        //replaced = replaced.replace(/input/g, 'span').replace("&lt;","<").replace("&gt;",">");
        /*var printWindow = window.open('', '', 'height=400,width=800');
        printWindow.document.write('<html><head>');
        printWindow.document.write('<style>.editor-root ul,.editor-root ol{padding-left:0px !important}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) ". ";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) ". ";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) ". ";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) ". ";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) ". ";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}body{margin:0px}.toolbar-draft,.geosuggest__suggests-wrapper{display:none}.professional-date_to-before{margin-top:-4px}</style>');
        printWindow.document.write('</head><body><div style="pointer-events:none">');
        printWindow.document.write(replaced);
        printWindow.document.write('</div><h6 style="text-align: center">Engineered by HIRATION</h6>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        setTimeout(function(){ printWindow.print(); }, 1000);
        printWindow.print();
        */
        var userPDFdata = {};
        userPDFdata['html'] = str;
        userPDFdata['design_template_id'] = this.props.design_template_id;
        userPDFdata['primary_color'] = this.props.primary_color;
        userPDFdata['secondary_color'] = this.props.secondary_color;
        userPDFdata['pdf_name'] = this.props.personal_info.name.replace(/ /g, '_') + '_' + this.props.content_template_name.replace(/ /g, '_');
        this.props.printPDF(userPDFdata);
        // var printWindow = window.open('', '', 'height=400,width=800');
        // printWindow.document.write(str)
        // setTimeout(function(){ printWindow.print(); }, 1000);
        // printWindow.print();

        if (this.props.basic_builder) {
          // Need to unset shadow_node as it might introduce certain styliing changes otherwise
          this.setState({ shadow_generated_JSX_databox: false });
          // Reload desing for basic builder, this is shit hack. useless call to server.
          this.props.loadDesignTemplateData(window._hiration.design_template_id);
        }
      } else {
        this.setState({ upgrade: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {

      if (prevProps != this.props) {

        var scripts = document.querySelectorAll(".runscript");
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(scripts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var value = _step.value;

            eval(value.text.replace("&lt;", "<").replace("&gt;", ">")); //Find a better solution
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.addCompleteStyling(this.props);

        if (prevProps.analysis_mode_on != this.props.analysis_mode_on) {
          this.setState({ resume_analysis_visible: this.props.analysis_mode_on });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      // const {info, load} = this.props; // eslint-disable-line no-shadow
      //const styles = require('./Design.scss');


      var _state = this.state,
          side_nav_visible = _state.side_nav_visible,
          resume_analysis_visible = _state.resume_analysis_visible;
      var _state2 = this.state,
          isReady = _state2.isReady,
          isRunning = _state2.isRunning,
          joyrideOverlay = _state2.joyrideOverlay,
          joyrideType = _state2.joyrideType,
          selector = _state2.selector,
          stepIndex = _state2.stepIndex,
          steps = _state2.steps,
          autoStart = _state2.autoStart,
          scrollOffset = _state2.scrollOffset,
          disableOverlay = _state2.disableOverlay;
      // Moving it  inside to remove bug

      if (this.state.loading || this.state.loading_for_basic_builder) {
        return _react2.default.createElement(
          _semanticUiReact.Dimmer.Dimmable,
          { as: _semanticUiReact.Segment, dimmed: false },
          _react2.default.createElement(_semanticUiReact.Dimmer, { active: false }),
          _react2.default.createElement(
            'div',
            { style: {
                width: 800,
                margin: '50px auto',
                backgroundColor: 'white',
                padding: 10,
                boxShadow: '0px 4px 8px grey'
              } },
            _react2.default.createElement(_reactContentLoader2.default, {
              height: 130,
              type: 'facebook'
            }),
            _react2.default.createElement(MyLoader, null),
            _react2.default.createElement(MyLoader, null),
            _react2.default.createElement(MyLoader, null),
            _react2.default.createElement(MyLoader, null)
          )
        );
      } else {

        // const { design_template_data } = this.props;
        // var generated_JSX_databox_pre = htmlParser.parseWithInstructions(
        //      design_template_data,
        //      isValidNode,
        //      this.processingInstructionsPreDataBox(this.props)
        //    );
        //
        //     // console.log(generated_JSX_databox_pre);
        //  var generated_JSX_databox = htmlParser.parseWithInstructions(
        //       ReactDOMServer.renderToStaticMarkup(generated_JSX_databox_pre[6]).replace(/&quot;/g, "'"),
        //       isValidNode,
        //       this.processingInstructionsPostDataBox(this.props)
        //     );
        // console.log(generated_JSX_databox);
        // this.setState({some_randome_key: generated_JSX_databox});
        // this.state.generated_JSX_databox = generated_JSX_databox;
        return _react2.default.createElement(
          'div',
          { className: 'vEditorWrapper', style: { background: '#eaeaea', paddingTop: 1 } },
          _react2.default.createElement(
            _semanticUiReact.Menu,
            { className: 'vEditorNav', style: { marginTop: '45px' }, widths: 3, fixed: 'top', size: 'small' },
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                className: 'item-1',
                onClick: function onClick() {
                  _this4.props.cleanTemplateData();
                  _this4.props.pushState(_this4.props.base_url + '/choose-design');
                  _this4.props.ReactGA.event({
                    category: 'Resume - Top Nav',
                    action: 'New Resume',
                    label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                  });
                },
                name: 'new-resume' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus square outline' }),
              'New ',
              this.props.type_of_document
            ),
            !this.props.basic_builder && _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                className: 'item-2',
                onClick: function onClick() {
                  _this4.props.pushState(_this4.props.base_url + '/choose-design/' + _this4.props.design_template_id);
                  _this4.props.ReactGA.event({
                    category: 'Resume - Top Nav',
                    action: 'Change Design',
                    label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                  });
                },
                name: 'change-template' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }),
              'Change Design'
            ),
            (this.props.content_template_free || this.props.subscribed || this.props.all_templates_free) && _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                className: 'item-3',
                onClick: function onClick() {
                  // this.printNode(this.element);
                  _this4.download_resume(_this4.element);
                  _this4.props.ReactGA.event({
                    category: 'Resume - Top Nav',
                    action: 'Download ' + _this4.props.type_of_document,
                    label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                  });
                },
                name: 'save' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
              this.props.type_of_document == 'Personal Website' ? 'Launch Personal Website' : 'Download ' + this.props.type_of_document
            ),
            !(this.props.content_template_free || this.props.subscribed || this.props.all_templates_free) && _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                onClick: function onClick() {
                  return window.open('/payment');
                },
                name: 'save' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'write' }),
              'Upgrade to Download'
            )
          ),
          _react2.default.createElement(_components.LeftMenu, null),
          resume_analysis_visible && _react2.default.createElement(_components.ResumeAnalysis, null),
          this.props.show_save_button && _react2.default.createElement(_components.SaveButton, null),
          _react2.default.createElement(
            'div',
            {
              ref: function ref(element) {
                return _this4.element = element;
              },
              style: { marginTop: 75, paddingBottom: 75 },
              className: 'documentToPrint ' + styles.pageBreak
            },
            this.state.generated_JSX_databox
          ),
          this.props.basic_builder && _react2.default.createElement(
            'div',
            { style: { display: 'block' } },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(shadowElement) {
                  return _this4.shadowElement = shadowElement;
                },
                style: { marginTop: 75, paddingBottom: 75 },
                className: styles.pageBreak
              },
              this.state.shadow_generated_JSX_databox
            )
          ),
          _react2.default.createElement(_semanticUiReact.Loader, {
            style: { position: 'fixed', left: '6%', top: '96%' },
            active: this.props.saving_data
          }),
          this.props.saved_data && !this.props.saving_data && _react2.default.createElement(
            _semanticUiReact.Label,
            { className: 'saveCheckMark', style: { position: 'fixed', right: '92%', top: '92%', display: '-webkit-box' } },
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true,
              inverted: true,
              color: 'teal',
              name: 'checkmark',
              size: 'large'
            }),
            _react2.default.createElement(
              'p',
              { style: { fontSize: '10px' } },
              this.getLastEditTime(new Date())
            )
          ),
          this.state.saved_once && !this.props.saved_data && !this.props.saving_data && _react2.default.createElement(
            _semanticUiReact.Label,
            { style: { position: 'fixed', right: '92%', top: '92%', display: '-webkit-box' } },
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true,
              inverted: true,
              color: 'red',
              name: 'x',
              size: 'large'
            }),
            _react2.default.createElement(
              'p',
              { style: { fontSize: '10px' } },
              'Can\'t save. Try in some time.'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal,
            { open: this.props.printing, basic: true, size: 'small' },
            _react2.default.createElement(_semanticUiReact.Header, { icon: 'archive', content: 'Engineering your ' + this.props.type_of_document + ', please wait...' }),
            _react2.default.createElement(
              _semanticUiReact.Modal.Content,
              null,
              _react2.default.createElement(_semanticUiReact.Loader, {
                active: true,
                style: { position: 'relative', top: 50 }
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal,
            { open: this.state.printing_success, basic: true, size: 'small' },
            this.props.show_resume_review_on_download && _react2.default.createElement(
              _semanticUiReact.Modal.Actions,
              { style: { paddingTop: '50px', paddingLeft: '21px' } },
              _react2.default.createElement(_semanticUiReact.Header, { style: { color: 'white', paddingBottom: '17.5px', background: 'none' }, icon: 'star', content: 'Get your resume reviewed by experts for free:' }),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'grey',
                  inverted: true,
                  onClick: function onClick() {
                    window.open('/free-resume-review');
                  } },
                'Get Resume Review'
              )
            ),
            _react2.default.createElement(_semanticUiReact.Header, { icon: 'save', content: 'Click here to view your ' + this.props.type_of_document + ':' }),
            _react2.default.createElement(
              _semanticUiReact.Modal.Actions,
              null,
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'green',
                  inverted: true,
                  onClick: function onClick() {
                    window.open(_this4.props.print_url);
                    _this4.setState({ printing_success: false });
                    _this4.props.ReactGA.event({
                      category: 'Resume - Download Resume ' + _this4.props.design_template_name + ' - ' + _this4.props.content_template_name,
                      action: 'View PDF',
                      label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
                    });
                  }
                },
                'View ',
                this.props.type_of_document
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal,
            { open: this.props.show_section_editor },
            _react2.default.createElement(_components.SectionEditor, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal,
            { style: { marginTop: '0px' }, open: this.props.show_social_editor },
            _react2.default.createElement(_components.SocialEditor, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal,
            { open: this.state.upgrade, basic: true, size: 'small' },
            _react2.default.createElement(_semanticUiReact.Header, {
              icon: 'lightning',
              content: this.props.type_of_document == 'Personal Website' ? 'Upgrade your Account to Deploy your ' + this.props.type_of_document : 'Upgrade your Account to Download your ' + this.props.type_of_document }),
            _react2.default.createElement(
              _semanticUiReact.Modal.Actions,
              null,
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'red',
                  inverted: true,
                  onClick: function onClick() {
                    _this4.setState({ upgrade: false });
                  }
                },
                'Cancel'
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'green',
                  inverted: true,
                  onClick: function onClick() {
                    window.open('/payment');
                    _this4.setState({ upgrade: false });
                    _this4.props.pushState(_this4.props.base_url + '');
                  }
                },
                'Upgrade'
              )
            )
          )
        );
      }
    }
  }]);
  return VEditor;
}(_react.Component), _class2.propTypes = {}
//info: PropTypes.object,
//load: PropTypes.func.isRequired
, _temp2)) || _class);
exports.default = VEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/VEditor/VEditor.js
// module id = 1765
// module chunks = 0